<template>
    <v-container fluid class="mt-0 pa-0">
	<v-card class="page-menu mb-3" rounded="0"  flat>
		<v-sheet
			elevation="2"
			rounded="0"
			height="40"
			max-width="100%"
			class="white--text light-blue darken-4 pt-2 pl-3 ml-0 mb-2"
		>
			<v-icon class="white--text mb-2">mdi-database</v-icon>
			マスタ管理・メンテナンス 
		</v-sheet>
		<v-card class="ma-5 rounded" >
			<v-system-bar color="gray" height="50">
				<v-card-subtitle class="text-h6 font-weight-bold">
					メールテンプレート一覧
				</v-card-subtitle>
				<v-spacer />
			</v-system-bar>
		</v-card>
	</v-card >

	<v-card class="ma-5 pa-5" outlined >
		<div style="max-width:600px">
		<v-data-table
			:headers="headers"
			:items="mailList"
			dense
			no-data-text="登録されていません"
			disable-pagination
			hide-default-footer
			height="200px"
			fixed-header
			class="master-list-table"		
		>
		<template v-slot:item.actions="{item}">
		<div class="py-1 d-flex d-inline-flex">
		<v-btn small class="pa-0 mx-2 btn-edit" @click="editMail(item)">編集</v-btn>
		</div>
		</template>
		</v-data-table>
		</div>
	</v-card>
	</v-container>
</template>
<script>
import { MESSAGE } from "../messages";
import {CONSTANT} from "../constant";
export default {
	data() {
		return {
			mailList:[],

			adminList:[],
			headers:[
				{
                    text: "CD",
                    sortable: true,
                    value: "mail_id",
					width:"150"
                },
				{
					text:"テンプレート名",
					sortable: true,
					value: "mail_name"
				},
				{
					text:"編集",
					sortable: false,
					value: "actions",
					align:'center',
					width:"160"
				}
			],
		}
	},
	mounted(){
		this.getMailtemplate();
	},
	methods:{
		async getMailtemplate(){
			this.mailList=[];
			const res = await this.axios.post('mail-template-list');
			if(res.data.resultCode === CONSTANT.RETURN_NORMAL){
				this.mailList = res.data.resultData.mail_list;
			}
		},
		editMail(item){
            this.$store.commit('setMailId', item.mail_id);
            this.$router.push({name: "mailedit"});
		},
	}


}
</script>